export default __webpack_public_path__ + "static/media/remittance_example.f5a64668.png";